module.exports = __webpack_public_path__ + "img/list1.feee5576.jpg";